import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyBIk-1Gc4xnDitceYry734sQKKleJtYwv0",
  authDomain: "fennex-a05b9.firebaseapp.com",
  databaseURL: "https://fennex-a05b9.firebaseio.com",
  projectId: "fennex-a05b9",
  storageBucket: "fennex-a05b9.appspot.com",
  messagingSenderId: "146865974254",
  appId: "1:146865974254:web:7abf0657b14c1f33b87cff",
  measurementId: "G-15137XGJ7X"
}
firebase.initializeApp(config)
firebase.analytics();

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()

// firebase collections
const usersCollection = db.collection('users')

export {
  db,
  auth,
  usersCollection
}
